import { Button as B } from '../../../views';
import type { ButtonProps } from '../../../views/Button';
export type { ButtonProps } from '../../../views/Button';

export function Button({ ...props }: ButtonProps) {
    return <B {...props} />;
}
